define([
//        'text!customerEdge/quoteandbind/common/views/account-lookup.html',
        'text!edge/quoteandbind/common/views/base-qnb-wizard.html',
        'text!edge/quoteandbind/common/views/quote-details.html',
        'text!edge/quoteandbind/common/views/payment-details.html',
        'text!customerEdge/quoteandbind/common/views/payment-confirmation.html',
        'text!edge/quoteandbind/common/views/contact-us.html',
        'text!edge/quoteandbind/common/views/confirmation.html',
        'text!customerEdge/quoteandbind/ho/views/next-steps.html',
        'text!edge/quoteandbind/common/views/zip-code.html',

//        'customerEdge/quoteandbind/common/controllers/AccountLookupCtrl',
        'edge/quoteandbind/common/controllers/QuoteEntryCtrl',
        'edge/quoteandbind/common/controllers/BaseQnbWizardCtrl',
        'edge/quoteandbind/common/controllers/QuoteDetailsCtrl',
        'edge/quoteandbind/common/controllers/PaymentDetailsCtrl',
        'customerEdge/quoteandbind/common/controllers/PaymentConfirmationCtrl',
        'edge/quoteandbind/common/controllers/ContactUsCtrl',
        'edge/quoteandbind/common/controllers/ConfirmationCtrl',
        'customerEdge/quoteandbind/ho/controllers/NextStepsCtrl',
        'edge/quoteandbind/common/controllers/ZipCodeCtrl',
        'edge/platform/featuredetection/ApplicationFeatures'],
    ( BaseQnbWizardView, QuoteDetailsView, PaymentDetailsView,PaymentConfirmationView, ContactUsView, ConfirmationView, NextStepsView, ZipCodeView, QuoteEntryCtrl,
        BaseQnbWizardCtrl, QuoteDetailsCtrl, PaymentDetailsCtrl,PaymentConfirmationCtrl, ContactUsCtrl, ConfirmationCtrl, NextStepsCtrl, ZipCodeCtrl) => {
    return RootStates => {

    const parentState = RootStates.quote_bind;
const wizardParentState = 'baseQnbWizard';
var homeState = RootStates.home;

return {
    //changed for AAA : added account lookup state
    // CHG0031104 - Changed back to Zipcode page
    /*landingAccount: {
        name: 'landingAccount',
        parent: parentState,
        url:'/home',
        controller: AccountLookupCtrl,
        template: AccountLookupView,
        data: {
            errorMsg: null,
            actions: {

                next: 'zipCode'
            },
            homeState: homeState
        }
    },*/



    zipCode: {
        name: 'zipCode',
        parent: parentState,
        url: '/zipCode?account',
        controller: ZipCodeCtrl,
        template: ZipCodeView
    },

    quoteentry: {
        name: 'quoteentry',
        parent: parentState,
        url: '/quoteentry',
        controller: QuoteEntryCtrl,
        params: {
            quoteID: null, //provided when resuming a draft submission
            postalCode: null, //provided when resuming or starting a submission
            productCode: null,  //provided when starting a submission
            effectiveDate: null, //provided when starting a submission
            agentportalnewsubmission: null, //provided when starting a quote from gpa,
            account: null, // provided when starting a quote from amp
            shouldUpdateEffectiveDate: null // provided when starting a quote from qnb
        },
        resolve: {
            originState: ['$state', ($state) => {
                //remember the state we came from so we can return if there is an error loading the claim
                return {name: $state.current, params: $state.params};
}]
}
},

baseQnbWizard: {
    parent: parentState,
        url: '/qnb-flow',
        controller: BaseQnbWizardCtrl,
        template: BaseQnbWizardView,
        resolve: {
        submissionViewModel: ['StateUtils', StateUtils => {
            return () => StateUtils.dataForState(wizardParentState).model;
    }]
}
},

quoteDetails: {
    name: 'quoteDetails',
        parent: wizardParentState,
        controller: QuoteDetailsCtrl,
        template: QuoteDetailsView
},



paymentDetails: {
    name: 'paymentDetails',
        parent: wizardParentState,
        template: PaymentDetailsView,
        controller: PaymentDetailsCtrl
},

paymentConfirmation:{
    name: 'paymentConfirmation',
        parent: wizardParentState,
        template: PaymentConfirmationView,
        controller: PaymentConfirmationCtrl

},

contactUs: {
    name: 'contactUs',
        url: '/contactus',
        parent: parentState,
        controller: ContactUsCtrl,
        template: ContactUsView,
        params: {
        returnStateInfo: null,
            errorMsg: null,
            quoteID: null
    }
},

qnbconfirmation: {
    name: 'confirmation',
        url: '/qnbconfirmation',
        parent: parentState,
        controller: ConfirmationCtrl,
        template: ConfirmationView,
        params: {
        returnStateInfo: null,
            quoteSummary: null
    }
},
nextSteps: {
    name: 'nextSteps',
        parent: parentState,
        template: NextStepsView,
        controller: NextStepsCtrl,
        params: {
        returnStateInfo: null,
        submission: null
    }
}
};
};
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/common/config/RouteConfig.js
 **/